import React from 'react';
// menu
export default ({ className, ...other }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="32" viewBox="0 0 10 32">
    <text
      id="_-"
      data-name="-"
      transform="translate(0 26)"
      fill="#fff"
      fontSize="24"
      fontFamily="SegoeUI-Bold, Segoe UI"
      fontWeight="700"
    >
      <tspan x="0" y="0">
        &#8722;
      </tspan>
    </text>
  </svg>
);
